module.exports = __webpack_public_path__ + "static/media/restar.ab95656f.svg";